var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#199CB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7H13.5L15.5 12L13 13.5C14.071 15.6715 15.8285 17.429 18 18.5L19.5 16L24.5 18V22C24.5 22.5304 24.2893 23.0391 23.9142 23.4142C23.5391 23.7893 23.0304 24 22.5 24C18.5993 23.763 14.9202 22.1065 12.1568 19.3432C9.3935 16.5798 7.73705 12.9007 7.5 9C7.5 8.46957 7.71071 7.96086 8.08579 7.58579C8.46086 7.21071 8.96957 7 9.5 7Z",
    stroke: "#1D2024",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.f07d67b5e38086aa11e7b1c3f34d8749.svg";
export { ForwardRef as ReactComponent };